import { modalActions } from '@/redux/reducer/modal-reducer';
import { sessionActions } from '@/redux/reducer/session';

// Actions from SessionReducer
export const {
  loadingStart,
  loadingStop,
  login,
  logout,
  signup,
  loadSessionFromLocal,
  updateCompany,
  updateToken,
} = sessionActions;

// Actions from ModalReducer
export const { openModal, closeModal } = modalActions;
